import * as types from './actionTypes';
import api from 'api/';

export function getData(id) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const followedContributors = await api.getFollowedContributorsByUser(id);
      const userData = await api.getUserProfile(id);
      dispatch({
        type: types.LOADED,
        followedContributors,
        userData,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
